import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { PopupEventType } from '../../../type/offer_type';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss'],
})
export class PopupComponent implements OnInit {
  @Input() widthChild: number;
  @Input() sliderWrapper!: boolean;
  @Input() parent!: any;
  @Input() timeout: number;

  @Output() popupEvent = new EventEmitter<PopupEventType>();

  public leftCoordinate: number;
  public topCoordinate: number;
  public popupPosition: string;
  private isTouchEvent: boolean = false;
  private height: number;

  @HostListener('window:scroll', ['$event']) onScroll() {
    if (this.sliderWrapper) {
      this.calculateCoordinates();
    }
  }

  constructor() {
    //---get a height of the page for calculation a popup's position---
    const body = document.body,
      html = document.documentElement;

    this.height = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );
    //---get a height of the page for calculation a popup's position---
  }

  ngOnInit(): void {
    this.calculateCoordinates();
  }

  @HostListener('window:keydown.escape', ['$event'])
  handleEscKey(event: KeyboardEvent): void {
    this.closePopup();
  }

  calculateCoordinates(): void {
    this.leftCoordinate = this.parent.getBoundingClientRect().left;
    this.topCoordinate = this.parent.getBoundingClientRect().top;
    const topElement = this.topCoordinate + document.documentElement.scrollTop;

    this.popupPosition = this.height - topElement < 700 ? 'top' : 'bottom';
  }

  openPopup(): void {
    this.popupEvent.emit({ openPopup: true });
  }

  closePopup(timeout?: string): void {
    this.popupEvent.emit({ openPopup: false, timeout: timeout });
  }

  mouseEvent(openPopup: boolean): void {
    if (!this.isTouchEvent) {
      openPopup ? this.openPopup() : this.closePopup();
    }
  }

  touchEvent(): void {
    this.isTouchEvent = true;
    this.openPopup();
  }
}
